import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=f25022ae"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"
import style0 from "./Scene.vue?vue&type=style&index=0&id=f25022ae&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25022ae')) {
      api.createRecord('f25022ae', component.options)
    } else {
      api.reload('f25022ae', component.options)
    }
    module.hot.accept("./Scene.vue?vue&type=template&id=f25022ae", function () {
      api.rerender('f25022ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Scene/Scene.vue"
export default component.exports